import { format } from 'date-fns'

import { TimeFormat } from '../../models'

import { getCurrentLocale } from './getCurrentLocale'

export const formatHour = (hour: number): string =>
  format(new Date().setHours(hour, 0, 0, 0), TimeFormat.Standard, { locale: getCurrentLocale() })
